import { BoardContainer } from "./BoardContainer";
import { BattleManager } from "../BattleManager";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { TarFx } from "./TarFx";
import { AudioManager } from "../../../AudioManager";

export class Board extends Phaser.GameObjects.Container {

    public pointerContainer: Phaser.GameObjects.Container;
    public cellsContainer: Phaser.GameObjects.Container;
    public boardMatrix: number[][];
    public flagsBack: Phaser.GameObjects.Image[];
    public flags: Phaser.GameObjects.Sprite[];
    public foregroundRenderTexture: Phaser.GameObjects.RenderTexture;

    private f: number;
    private nextF: number;
    private tarFx: TarFx;
    private flagsAnimatedInLoop: boolean;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = - GameConstants.CELLS_SIZE * GameVars.currentMapData.size.c / 2;
        this.y = - (GameConstants.CELLS_SIZE * GameVars.currentMapData.size.r / 2);

        this.f = 0;
        this.nextF = 120 + Math.round(Math.random() * 60);
        this.flagsAnimatedInLoop = false;

        this.flagsBack = [];
        this.flags = [];

        this.pointerContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(this.pointerContainer);

        this.pointerContainer.setInteractive(new Phaser.Geom.Rectangle(0, - GameConstants.GAME_HEIGHT, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT * 4), Phaser.Geom.Rectangle.Contains);
        this.pointerContainer.on("pointerdown", this.onPointerDown, this);

        const map = this.scene.make.tilemap({ key: GameVars.currentMapData.name });
        const tileset = map.addTilesetImage("tileset" + (GameVars.currentMapZone + 1));

        const background = map.createStaticLayer("background", tileset, - GameConstants.CELLS_SIZE, 0);
        background.visible = false;

        const foreground1 = map.createStaticLayer("foreground_1", tileset, - GameConstants.CELLS_SIZE, 0);
        foreground1.visible = false;

        const foreground2 = map.createStaticLayer("foreground_2", tileset, - GameConstants.CELLS_SIZE, 0);
        foreground2.visible = false;

        const backgroundRenderTexture = this.scene.add.renderTexture(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        backgroundRenderTexture.draw(background);
        this.add(backgroundRenderTexture);

        // la altura de la mancha de brea debe ser un numero par!
        this.tarFx = new TarFx(this.scene, 10);
        this.add(this.tarFx);

        this.foregroundRenderTexture = this.scene.add.renderTexture(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.foregroundRenderTexture.draw(foreground1);
        this.foregroundRenderTexture.draw(foreground2);
        this.add(this.foregroundRenderTexture);

        this.boardMatrix = new Array(GameVars.currentMapData.size.r);

        for (let i = 0; i < this.boardMatrix.length; i++) {
            if (GameVars.plateausCells.length === 0) {
                this.boardMatrix[i] = new Array(GameVars.currentMapData.size.c).fill(1);
            } else {
                this.boardMatrix[i] = new Array(GameVars.currentMapData.size.c).fill(0);
            }  
        }

        for (let i = 0; i < GameVars.plateausCells.length; i++) {
            this.boardMatrix[GameVars.plateausCells[i].r][GameVars.plateausCells[i].c] = 1;
        }

        for (let i = 0; i < GameVars.enemiesPathsCells.length; i++) {
            for (let j = 0; j < GameVars.enemiesPathsCells[i].path.length; j++) {

                if (GameVars.enemiesPathsCells[i].path[j].c < 0 || GameVars.enemiesPathsCells[i].path[j].r < 0 || GameVars.enemiesPathsCells[i].path[j].c >= GameVars.currentMapData.size.c || GameVars.enemiesPathsCells[i].path[j].r >= GameVars.currentMapData.size.r) {
                    continue;
                }

                this.boardMatrix[GameVars.enemiesPathsCells[i].path[j].r][GameVars.enemiesPathsCells[i].path[j].c] = 2;
            }
        }

        this.cellsContainer = new Phaser.GameObjects.Container(this.scene);
        this.add(this.cellsContainer);

        for (let i = 0; i < this.boardMatrix.length; i++) {
            for (let j = 0; j < this.boardMatrix[i].length; j++) {
                if (this.boardMatrix[i][j] === 1) {
                    
                    const img = this.scene.add.sprite(GameConstants.CELLS_SIZE * j + GameConstants.CELLS_SIZE / 2, (GameConstants.CELLS_SIZE * i + GameConstants.CELLS_SIZE / 2) - 12, "texture_atlas_1", "flag_build_1");
                    img.setInteractive(new Phaser.Geom.Rectangle(0, 12, GameConstants.CELLS_SIZE, GameConstants.CELLS_SIZE), Phaser.Geom.Rectangle.Contains);
                    img.on("pointerdown", this.onDownFlag, this);
                    this.cellsContainer.add(img);
                    this.flags.push(img);
                }
            }
        }
    }

    public update(time: number, delta: number): void {

        if(this.flags.length === 0 || (GameVars.currentMapZone === 0 && GameVars.currentMapCount === 0)) {
            return;
        }

        if(BattleManager.anutoEngine.credits < 50) {

            if(this.flagsAnimatedInLoop) {

                this.flagsAnimatedInLoop = false;

                for(let i = 0; i < this.flags.length; i ++) {
                    this.flags[i].anims.stop()
                }
            }

            this.f++;

            if (this.f === this.nextF) {
                this.f = 0;
                this.nextF = 120 + Math.round(Math.random() * 60);
                this.flags[Math.floor(Math.random() * this.flags.length)].anims.play("flag_build");
            }

        } else if(!this.flagsAnimatedInLoop) {

            this.flagsAnimatedInLoop = true;

            for(let i = 0; i < this.flags.length; i ++) {
                this.flags[i].anims.play("flag_build_loop");
            }
        }
    }

    public launchFreezeAttack(): void {

        this.tarFx.activate();

        this.addKing();
    }

    public addKing(): void {

        const path = new Phaser.Curves.Path(GameConstants.GAME_WIDTH + 100, GameConstants.GAME_HEIGHT / 2 - 150 + Math.random() * 300);

        for (let i = 0; i < 8; i++) {
            
            if (i % 2 === 0) {
                path.ellipseTo(-100, 40, 180, 360, true, 0);
            } else {
                path.ellipseTo(-100, 40, 180, 360, false, 0);
            }
        }

        const king = this.scene.add.follower(path, 0, 0, "texture_atlas_1");
        king.setScale(1.35);
        this.add(king);

        king.anims.play("surfer_king");
        
        king.startFollow({
            duration: GameVars.timeStepFactor === 1 ? 4000 : 2000,
            positionOnPath: true,
            ease: Phaser.Math.Easing.Linear,
            onComplete: () => {
                king.destroy();
            },
            onCompleteScope: this
        });

        AudioManager.playSound("king_tar_wave");
    }

    public removeFreezeAttack(): void {
        
        this.tarFx.deactivate();
    }

    public addTurretBackground(position: {c: number, r: number}): void {

        let bck = new Phaser.GameObjects.Image(this.scene, GameConstants.CELLS_SIZE * position.c + GameConstants.CELLS_SIZE / 2, (GameConstants.CELLS_SIZE * position.r + GameConstants.CELLS_SIZE / 2) - 12, "texture_atlas_1", "flag_build_1");
        bck.alpha = .01;
        bck.setInteractive();
        bck.on("pointerdown", () => { 
            //
        }, this);
        this.cellsContainer.add(bck);

        this.flagsBack.push(bck);

        for (let i = 0; i < this.flags.length; i++) {

            if (this.flags[i].x === GameConstants.CELLS_SIZE * position.c + GameConstants.CELLS_SIZE / 2 && this.flags[i].y === GameConstants.CELLS_SIZE * position.r + GameConstants.CELLS_SIZE  / 2 - 12) {
                this.flags[i].visible = false;
                break;
            }
        }
    }

    public removeTurretBackground(position: {c: number, r: number}): void {

        for (let i = 0; i < this.flagsBack.length; i++) {

            if (this.flagsBack[i].x === GameConstants.CELLS_SIZE * position.c + GameConstants.CELLS_SIZE / 2 && this.flagsBack[i].y === GameConstants.CELLS_SIZE * position.r + GameConstants.CELLS_SIZE  / 2 - 12) {
                this.flagsBack[i].destroy();
                this.flagsBack.splice(i, 1);
                break;
            }
        }

        for (let i = 0; i < this.flags.length; i++) {

            if (this.flags[i].x === GameConstants.CELLS_SIZE * position.c + GameConstants.CELLS_SIZE / 2 && this.flags[i].y === GameConstants.CELLS_SIZE * position.r + GameConstants.CELLS_SIZE / 2 - 12) {
                this.flags[i].visible = true;
                break;
            }
        }
    }

    private onPointerDown(pointer: Phaser.Input.Pointer): void {

        BattleManager.hideSelectTurret();
        BoardContainer.currentInstance.onPointerDown();
    }

    private onDownFlag(pointer: Phaser.Input.Pointer, a: any): void {

        if (BattleManager.anutoEngine.gameOver || BattleManager.anutoEngine.win) {
            return;
        }

        AudioManager.playSound("btn_click");

        let scaleX = this.scene.sys.game.device.os.desktop ? 1 : GameVars.scaleX + GameVars.contrascaleX;
        
        BattleManager.showSelectTurret(Math.floor(((pointer.x - (GameConstants.GAME_WIDTH / 2 + (this.x * scaleX))) / scaleX) / GameConstants.CELLS_SIZE), Math.floor((pointer.y - (GameConstants.GAME_HEIGHT / 2 + GameConstants.CELLS_SIZE / 2 + this.y)) / (GameConstants.CELLS_SIZE)));
        BoardContainer.currentInstance.onPointerDown();
    }

    private selectTypeCell(i: number, j: number): string {

        let boarderCells: number[] = [0, 0, 0, 0, 0, 0, 0, 0];

        if (this.boardMatrix[i - 1] && this.boardMatrix[i - 1][j] && this.boardMatrix[i - 1][j] === 2) {
            boarderCells[0] = 1;
        }

        if (this.boardMatrix[i - 1] && this.boardMatrix[i - 1][j + 1] && this.boardMatrix[i - 1][j + 1] === 2) {
            boarderCells[1] = 1;
        }

        if (this.boardMatrix[i] && this.boardMatrix[i][j + 1] && this.boardMatrix[i][j + 1] === 2) {
            boarderCells[2] = 1;
        }

        if (this.boardMatrix[i + 1] && this.boardMatrix[i + 1][j + 1] && this.boardMatrix[i + 1][j + 1] === 2) {
            boarderCells[3] = 1;
        }

        if (this.boardMatrix[i + 1] && this.boardMatrix[i + 1][j] && this.boardMatrix[i + 1][j] === 2) {
            boarderCells[4] = 1;
        }

        if (this.boardMatrix[i + 1] && this.boardMatrix[i + 1][j - 1] && this.boardMatrix[i + 1][j - 1] === 2) {
            boarderCells[5] = 1;
        }

        if (this.boardMatrix[i] && this.boardMatrix[i][j - 1] && this.boardMatrix[i][j - 1] === 2) {
            boarderCells[6] = 1;
        }

        if (this.boardMatrix[i - 1] && this.boardMatrix[i - 1][j - 1] && this.boardMatrix[i - 1][j - 1] === 2) {
            boarderCells[7] = 1;
        }

        let cells = ["20"];

        if (boarderCells[0] === 1 && boarderCells[2] === 1 && boarderCells[6] === 1) {
            cells = ["76"];
        } else if (boarderCells[0] === 1 && boarderCells[2] === 1 && boarderCells[4] === 1) {
            cells = ["77"];
        } else if (boarderCells[6] === 1 && boarderCells[2] === 1 && boarderCells[4] === 1) {
            cells = ["79"];
        } else if (boarderCells[6] === 1 && boarderCells[0] === 1 && boarderCells[4] === 1) {
            cells = ["73"];
        } else if (boarderCells[4] === 1 && boarderCells[6] === 1) {
            if (boarderCells[1] === 1) {
                cells = ["71"];
            } else {
                cells = ["17"];
            }  
        } else if (boarderCells[4] === 1 && boarderCells[2] === 1) {
            if (boarderCells[7] === 1) {
                cells = ["72"];
            } else {
                cells = ["13"];
            }  
        } else if (boarderCells[0] === 1 && boarderCells[6] === 1) {
            if (boarderCells[3] === 1) {
                cells = ["64"];
            } else {
                cells = ["64"];
            }
        } else if (boarderCells[0] === 1 && boarderCells[2] === 1) {
            if (boarderCells[5] === 1) {
                cells = ["65"];
            } else {
                cells = ["33"];
            }
        } else if (boarderCells[0] === 1 && boarderCells[4] === 1) {
            cells = ["74"];
        } else if (boarderCells[2] === 1 && boarderCells[6] === 1) {
            cells = ["78"];
        } else if (boarderCells[6] === 1) {
            if (boarderCells[1] === 1 && boarderCells[3] === 1) {
                cells = [""];
            } else if (boarderCells[1] === 1) {
                cells = ["59"];
            } else if (boarderCells[3] === 1) {
                cells = ["50"];
            } else {
                cells = ["10", "29", "47"];
            }
            
        } else if (boarderCells[0] === 1) {
            if (boarderCells[5] === 1 && boarderCells[3] === 1) {
                cells = [""];
            } else if (boarderCells[5] === 1) {
                cells = ["49"];
            } else if (boarderCells[3] === 1) {
                cells = ["48"];
            } else {
                cells = ["32", "38", "53", "54", "55"];
            }
        } else if (boarderCells[2] === 1) {
            if (boarderCells[5] === 1 && boarderCells[7] === 1) {
                cells = [""];
            } else if (boarderCells[5] === 1) {
                cells = ["51"];
            } else if (boarderCells[7] === 1) {
                cells = ["60"];
            } else {
                cells = ["06", "21", "43"];
            }
        } else if (boarderCells[4] === 1) {
            if (boarderCells[1] === 1 && boarderCells[7] === 1) {
                cells = [""];
            } else if (boarderCells[1] === 1) {
                cells = ["66"];
            } else if (boarderCells[7] === 1) {
                cells = ["67"];
            } else {
                cells = ["02", "03", "04", "12", "18"];
            }
        } else if (boarderCells[1] === 1 && boarderCells[3] === 1 && boarderCells[5] === 1 && boarderCells[7] === 1) {
            cells = ["75"];
        } else if (boarderCells[3] === 1 && boarderCells[5] === 1 && boarderCells[7] === 1) {
            cells = ["63"];
        } else if (boarderCells[5] === 1 && boarderCells[1] === 1 && boarderCells[7] === 1) {
            cells = ["70"];
        } else if (boarderCells[3] === 1 && boarderCells[1] === 1 && boarderCells[7] === 1) {
            cells = ["69"];
        } else if (boarderCells[3] === 1 && boarderCells[1] === 1 && boarderCells[5] === 1) {
            cells = ["62"];
        } else if (boarderCells[3] === 1 && boarderCells[5] === 1) {
            cells = ["61"];
        } else if (boarderCells[7] === 1 && boarderCells[5] === 1) {
            cells = ["58"];
        } else if (boarderCells[7] === 1 && boarderCells[1] === 1) {
            cells = ["68"];
        } else if (boarderCells[3] === 1 && boarderCells[1] === 1) {
            cells = ["57"];
        } else if (boarderCells[5] === 1) {
            cells = ["19"];
        } else if (boarderCells[7] === 1) {
            cells = ["56"];
        } else if (boarderCells[1] === 1) {
            cells = ["31"];
        } else if (boarderCells[3] === 1) {
            cells = ["11"];
        } else {
            cells = ["20", "30", "40", "41", "42"];
        }

        return cells[Math.floor(Math.random() * cells.length)];
    }
}
